import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export function OwnerCredentials() {
  const [form,setForm]=useState({current_password:"",email:"",password:"",confirmation:""});
  const [busy,setBusy]=useState(false);
  const set=(key)=>(event)=>setForm({...form,[key]:event.target.value});
  const submit=async(event)=>{
    event.preventDefault();setBusy(true);
    try {
      await api.post("/auth/owner-credentials",form);
      setForm({current_password:"",email:"",password:"",confirmation:""});
      localStorage.removeItem("access_token");
      window.location.assign("/login");
    } catch(error){toast.error(errMsg(error));} finally{setBusy(false);}
  };
  return <section className="doc-card p-5 space-y-3">
    <h2 className="text-lg font-semibold">Owner sign-in</h2>
    <p className="text-sm text-slate-600">Update the owner email and password while keeping the account and history. Existing sessions will end after saving.</p>
    <form className="grid sm:grid-cols-2 gap-3" onSubmit={submit}>
      <label className="text-sm">Current password<input className="field" type="password" autoComplete="current-password" data-testid="owner-credentials-current_password" value={form.current_password} onChange={set("current_password")} required /></label>
      <label className="text-sm">New email<input className="field" type="email" autoComplete="username" data-testid="owner-credentials-email" value={form.email} onChange={set("email")} required /></label>
      <label className="text-sm">New password<input className="field" type="password" autoComplete="new-password" minLength={12} maxLength={72} data-testid="owner-credentials-password" value={form.password} onChange={set("password")} required /></label>
      <label className="text-sm">Type MIGRATE-OWNER<input className="field mono" autoComplete="off" data-testid="owner-credentials-confirmation" value={form.confirmation} onChange={set("confirmation")} required /></label>
      <button data-testid="owner-credentials-submit" className="btn-primary w-fit" disabled={busy||form.confirmation!=="MIGRATE-OWNER"}>{busy?"Saving…":"Update owner sign-in"}</button>
    </form>
  </section>;
}
